/* Sequoia Fitness | Website: https://www.sequoia.fitness | Author: Ali Hosseini | Copyright (c) 2026 sequoia.fitness. All rights reserved. */
/* Designed and developed by Pouria Shabani | https://linkedin.com/in/pouriashabani */

import Header from '../components/Header.jsx'
import Footer from '../components/Footer.jsx'
import TabBar from '../components/TabBar.jsx'
import Fab from '../components/Fab.jsx'
import MobileMenu from '../components/MobileMenu.jsx'
import useMotion from '../hooks/useMotion.js'

export default function SiteShell({ children, variant, bare }) {
  useMotion()
  return (
    <>
      {!bare && <Header />}
      <main className={'pg' + (variant ? ' pg--' + variant : '')}>{children}</main>
      {!bare && <Footer />}
      {!bare && <TabBar />}
      <Fab />
      {!bare && <MobileMenu />}
    </>
  )
}
